// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__eVPp5","title":"ClientCherryInfo_title__3QOUr","itemText":"ClientCherryInfo_itemText__2HB7p"};